import styled from "styled-components";
import { COLORS } from "styles/colors";
import { calcRem } from "styles/theme";

interface Props {
  isValidated?: boolean;
}

const TextArea = styled.textarea<Props>`
  width: 100%;
  min-height: 70px;
  border-radius: 2px;
  padding: 11px 15px;
  box-sizing: border-box;
  border: 1px solid #cacaca;
  font-size: ${calcRem(14)};

  &::placeholder {
    color: #abb5c5;
  }
  &:disabled {
    background-color: ${({ theme }) => theme.COLORS.DISABLED};
    border-color: ${({ theme }) => theme.COLORS.DISABLED_BORDER};
    color: ${({ theme }) =>
      theme.value === "light"
        ? `${theme.COLORS.WHITE}60`
        : theme.COLORS.LIGHTGRAY};
    cursor: not-allowed;
  }
  ${({ isValidated }) =>
    isValidated &&
    `
      border: 1px solid ${COLORS.VALIDATERED};
      background-color: #FFD5D5;
  `}
`;

export default TextArea;
